module.exports = __webpack_public_path__ + "img/img-12.e5db5f0d.png";